var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import CourseSectionService from "../../../../Services/CourseSection.service";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import DateService from "../../../../Services/Shared/Date.service";
import { getCourseSectionDetailPath } from "./CourseSectionRoutes";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import SearchField from "../../../Form/SearchField";
import { CourseSearch } from "../../../Presentational/Course/CourseSearch";
import { AcademicCalendarMultiSearch } from "../../../Presentational/AcademicCalendar/AcademicCalendarSearch";
import SelectAsyncField from "../../../Form/SelectAsyncField";
import PersonService from "../../../../Services/Person.service";
import NumberService from "../../../../Services/Shared/Number.service";
const PAGE_SIZE = 50;
const CourseSectionListTable = () => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({});
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No course sections found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return CourseSectionService.searchFull({
                courseIds: sArgs.courseIds,
                section: sArgs.section,
                instructorAffiliationIds: sArgs.instructorAffiliationIds,
                academicCalendarIds: sArgs.academicCalendarIds,
                srcSystemId: sArgs.srcSystemId,
                lmsId: sArgs.lmsId,
            }, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Source System ID",
                sortId: "COURSE_SECTION_SRC_SYSTEM_ID",
            },
            {
                title: "Term",
                sortId: "COURSE_SECTION_ACADEMIC_CALENDAR",
            },
            {
                title: "Course",
                sortId: "COURSE_SECTION_COURSE",
            },
            {
                title: "Section",
                sortId: "COURSE_SECTION_SECTION",
            },
            {
                title: "Start",
                sortId: "COURSE_SECTION_START_DATE",
            },
            {
                title: "End",
                sortId: "COURSE_SECTION_END_DATE",
            },
            {
                title: "Instructor",
                sortId: "COURSE_SECTION_INSTRUCTOR_AFFILIATION",
            },
            {
                title: "Online",
                sortId: "COURSE_SECTION_ONLINE",
            },
            {
                title: "LMS ID",
                sortId: "COURSE_SECTION_LMS_ID",
            },
        ],
        rows: ({ data }) => data.map((courseSection, index) => {
            return [
                _jsx(Link, { to: getCourseSectionDetailPath(courseSection.id), children: courseSection.srcSystemId }, index),
                courseSection.academicCalendar.name,
                courseSection.course.fullName,
                courseSection.section,
                DateService.display(courseSection.startDate),
                DateService.display(courseSection.endDate),
                courseSection === null || courseSection === void 0 ? void 0 : courseSection.instructors.map((instructor) => instructor.fullName).join(", "),
                _jsx(BooleanDisplay, { val: courseSection.online }, index),
                courseSection.lmsId,
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "mb-3", children: ["Course Sections", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total)
                        ? `(${NumberService.format((_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total)})`
                        : ""] }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        var _c, _d;
                        setSearchArgs({
                            section: formState.section.toString(),
                            academicCalendarIds: (_c = formState.terms) === null || _c === void 0 ? void 0 : _c.map((t) => t.id),
                            courseIds: formState.course && [formState.course.id],
                            instructorAffiliationIds: (_d = formState.instructors) === null || _d === void 0 ? void 0 : _d.map((i) => i.affiliationId),
                            lmsId: formState.lmsId,
                            srcSystemId: formState.srcSystemId,
                        });
                    }), children: [_jsx(SearchField, { label: "Course", name: "course", as: (provided) => _jsx(CourseSearch, Object.assign({}, provided)) }), _jsx(TextField, { name: "section", label: "Section" }), _jsx(SearchField, { label: "Terms", name: "terms", as: (provided) => _jsx(AcademicCalendarMultiSearch, Object.assign({}, provided)) }), _jsx(SelectAsyncField, { optionRenderer: (option) => {
                                return (_jsx("div", { className: "d-flex", children: _jsxs("div", { className: "mr-1", children: [option.fullName, " (", option.studentId, ")"] }) }));
                            }, loadOptions: PersonService.searchEnabledNonStudent, valueKey: "affiliationId", label: "Instructors", name: "instructors", multi: true }), _jsx(TextField, { name: "srcSystemId", label: "Source System ID" }), _jsx(TextField, { name: "lmsId", label: "LMS ID" })] }) }), _jsx("div", { className: "py-2", children: table })] }));
};
const CourseSectionList = () => {
    return (_jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(CourseSectionListTable, {}) }));
};
export default CourseSectionList;
